/** 头像占位首字：优先昵称，其次 fallback（如 spaceId / label） */
export function avatarDisplayWord(
  name?: string | null,
  fallback?: string | null
): string {
  const n = name?.trim();
  if (n) {
    return n.slice(0, 1);
  }
  const f = fallback?.trim();
  if (f) {
    return f.slice(0, 1);
  }
  return "用";
}
